import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	InnerBlocks,
	useInnerBlocksProps,
} from '@wordpress/block-editor';
import { PanelBody } from '@wordpress/components';
import { useEffect } from '@wordpress/element';
import { useSelect, useDispatch } from '@wordpress/data';

import Style from './Style';

import metadata from './block.json';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId, isSelected } = props;
	const { blockId } = attributes;
	const { insertBlock } = useDispatch( 'core/block-editor' );
	useEffect( () => {
		if ( ! attributes.blockId || blockId !== clientId ) {
			setAttributes( { blockId: clientId } );
		}
	}, [ clientId ] );

	const { hasInnerBlocks } = useSelect(
		( select ) => {
			const block = select( 'core/block-editor' ).getBlock( clientId );
			return {
				hasInnerBlocks: !! block && block.innerBlocks.length > 0,
			};
		},
		[ clientId ]
	);

	const blockProps = useBlockProps( {
		className: `alpha-column-blocks alpha-column-block-${ clientId } ${
			! hasInnerBlocks ? 'is-empty' : ''
		}`,
	} );

	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		renderAppender:
			isSelected || ! hasInnerBlocks
				? InnerBlocks.ButtonBlockAppender
				: false,
	} );

	return (
		<>
			<Style { ...props } />
			{ isSelected && (
				<window.InspectorGenerator props={ props } blockJson={ metadata } />
			) }
			<div { ...innerBlocksProps } />
			{ /* {isSelected && (
				<button
					type="button"
					className="alpha-column-add-blocks-button"
					style={{
						position: 'absolute',
						left: '50%',
						bottom: '10px',
						transform: 'translateX(-50%)',
						zIndex: 10,
						background: '#fff',
						border: '1px solid #ddd',
						borderRadius: '6px',
						padding: '6px 16px',
						boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
						cursor: 'pointer',
					}}
					onClick={() => {
						// Open the block inserter and focus the inserter for this column block
						wp.data.dispatch('core/block-editor').openBlockInserter(clientId);
						wp.data.dispatch('core/edit-post').openGeneralSidebar('edit-post/block');
					}}
					aria-label="Add blocks"
				>
					+ Add Blocks
				</button>
			)} */ }
		</>
	);
}
